import { defaultTheme, Theme } from 'gd-design-library';
import { button } from './button';
import { snackbar } from './snackbar';
import { card } from './card';
import { wrapper } from './wrapper';
import { typography } from './typography';
import { breadcrumbs } from './breadcrumbs';
import { price } from './price';
import { carousel } from './carousel';
import { colors } from './colors';
import { select } from './select';
import { menu } from './menu';
import { input } from './input';
import { modal } from './modal';
import { stepper } from './stepper';
import { inputfile } from './inputfile';
import { font } from './font';
import { counter } from './counter';
import { inlineNotification } from './inlineNotification';
import { accordion } from './accordion';
import { list } from './list';
import { textarea } from './textarea';

export const gridKitTheme = {
  ...defaultTheme,
  name: 'volcanoGridKitTheme',
  colors,
  button,
  snackbar,
  card,
  wrapper,
  typography,
  breadcrumbs,
  price,
  carousel,
  select,
  menu,
  input,
  modal,
  stepper,
  inputfile,
  font,
  counter,
  inlineNotification,
  accordion,
  list,
  textarea
} as unknown as Theme;
